import { render, staticRenderFns } from "./RecurringRemarkListSideMenu.vue?vue&type=template&id=33200d5c&scoped=true"
import script from "./RecurringRemarkListSideMenu.vue?vue&type=script&lang=js"
export * from "./RecurringRemarkListSideMenu.vue?vue&type=script&lang=js"
import style0 from "./RecurringRemarkListSideMenu.vue?vue&type=style&index=0&id=33200d5c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33200d5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33200d5c')) {
      api.createRecord('33200d5c', component.options)
    } else {
      api.reload('33200d5c', component.options)
    }
    module.hot.accept("./RecurringRemarkListSideMenu.vue?vue&type=template&id=33200d5c&scoped=true", function () {
      api.rerender('33200d5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recurringremarks/RecurringRemarkListSideMenu.vue"
export default component.exports